<template>
  <base-section id="program-committee">
    <base-section-heading title="Program Committee" />

    <base-title
      title="Topic Chairs"
      size="text-h1"
    />
    <v-container>
      <v-row>
        <base-avatar-card
          title="Dependable AI and AI for Testing (Hot Topic)"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(general, i) in generals"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="general"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="Program Chair"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(program, i) in programs"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="program"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="Publicity Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(publicity, i) in publicities"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="publicity"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="Regional Liaison Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(regional, i) in regionals"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="regional"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="Virtualization Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(virtual, i) in virtuals"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="virtual"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
      <v-row>
        <base-avatar-card
          title="Web Resource Co-Chairs"
          align="left"
          horizontal
        />
      </v-row>
      <v-row>
        <v-col
          v-for="(web, i) in webs"
          :key="i"
          cols="12"
          md="6"
        >
          <base-avatar-card
            v-bind="web"
            align="left"
            horizontal
          />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'ProgramCommittee',

    data: () => ({
      topics: [
        {
          ones: [
            {
              title: 'Paolo Bernardi',
              src: require('@/images/committees/paolobernardi.jpg'),
              text: 'Politecnico di Torino, IT',
            },
          ],
        },
      ],
    }),
  }
</script>
